export default "__VITE_ASSET__07mkiIit__"